import { gql } from '@zenbusiness/application-commons-graphql';

import { ATTRIBUTES_FRAGMENT } from '../fragments/AttributesFragment';
import { UI_INSTRUCTION_FRAGMENT } from '../fragments/UiInstructionFragment';

export const SUBMIT_USER_INPUT_MUTATION = gql`
  mutation InteractWithAssistant(
    $identity: Identity!
    $input: JSON
    $threadUuid: UUID
    $messageUuid: UUID
    $mode: String = "post"
    $threadMode: ThreadMode
  ) {
    interactWithAssistant(
      identity: $identity
      input: $input
      threadUuid: $threadUuid
      messageUuid: $messageUuid
      mode: $mode
      threadMode: $threadMode
    ) {
      ok
      threadUuid
      data {
        id
        type
        attributes {
          ...AttributesFragment
        }
        meta {
          renderStrategy
        }
      }
      error
      meta
    }
  }
  ${ATTRIBUTES_FRAGMENT}
  ${UI_INSTRUCTION_FRAGMENT}
`;
